export default class GameModel {
	constructor({
		winType,
		isWinner,
		pattern,
		ticketURL,
		scratched,
		winAmount,
		price,
		prizeLevelNo,
		prizeLevelName,
		freeTicketCount,
	}) {
		this.isGameActive = false;
		this._isGamePlayed = scratched;
		this._winType = winType;
		this._isWinner = isWinner;
		this._winAmount = winAmount;
		this._pattern = pattern;
		this._ticketURL = ticketURL;
		this._scratched = scratched;
		this._price = price;
		this._prizeLevelNo = prizeLevelNo;
		this._prizeLevelName = prizeLevelName;
		this._freeTicketCount = freeTicketCount;
	}

	get isGameActive() {
		return this._isGameActive;
	}

	set isGameActive(value) {
		this._isGameActive = value;
	}

	get isGamePlayed() {
		return this._isGamePlayed;
	}

	set isGamePlayed(value) {
		this._isGamePlayed = value;
	}

	get isWinner() {
		return this._isWinner;
	}

	get winAmount() {
		if (this.isWinner) {
			return this._winAmount;
		}
		return "0.00";
	}

	get pattern() {
		return this._pattern;
	}

	get winType() {
		return {
			nowin: "Niete",
			1: "Geldgewinn",
			2: "Sachgewinn",
			3: "Freilos",
		}[this._winType];
	}

	get ticketURL() {
		return this._ticketURL;
	}
}
